<template>
  <t-form labelWidth="80px">
         <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
   <!-- <CptDefault :attribute="attribute" :currentCpt="currentCpt" /> -->
   <t-form-item label="时间范围">
      <t-switch v-model="attribute.timerange" />
    </t-form-item>
    <t-form-item label="时间格式">
      <t-select size="small" v-model="attribute.timeFormat">
        <t-option v-for="(item, index) in defaultTypeArray" :key="index" :label="item.label" :value="item.type" />
      </t-select>
    </t-form-item>
    <CptInputOptionBase :attribute="attribute" :currentCpt="currentCpt" @changeSize="changeSize"/>
    <!-- <e-collapse title="面板设置" :expand="true">
          <t-form-item label="显示图标">
      <t-switch v-model="attribute.timeIcon" />
    </t-form-item>
             <t-form-item label="图标颜色">
               <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.timeIconBg"
      />

    </t-form-item>
        <t-form-item label="面板背景色">
                    <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.panelBg"
      />

        </t-form-item>
        <t-form-item label="面板字体颜色">
                    <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.panelColor"
      />

          </t-form-item>
          <t-form-item label="选中字体颜色">
                      <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.activeColor"
      />

          </t-form-item>
          <t-form-item label="选中背景颜色">
                      <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.activeBgColor"
      />

          </t-form-item>
             <t-form-item label="按钮颜色">
                        <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.btnBg"
      />
 
          </t-form-item>
          <t-form-item label="按钮字体颜色">
                      <t-color-picker
        size="small"
        :colorModes="['monochrome']"
        format="RGBA"
        enableAlpha
        v-model="attribute.btnColor"
      />
  
          </t-form-item>
    </e-collapse> -->
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptDefault from "@/components/element/options/comp/cpt-default";
import CptInputOptionBase from "@/components/element/options/comp/cpt-input-option-base";
export default {
  name: "cpt-time-picker-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  components: { CptDefault,CptInputOptionBase ,CptData},
  data() {
    return {
      defaultTypeArray: [{type: "HH",label: "时"},{type: "HH:mm",label: "时分"},{type: "HH:mm:ss",label: "时分秒"}],
      sizeOptions: {
        small: { width: this.currentCpt.cptWidth, height: 24 },
        medium: { width: this.currentCpt.cptWidth, height: 32 },
        large: { width: this.currentCpt.cptWidth, height: 40 },
      },
    };
  },
  methods: {
     changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
  },
};
</script>

<style scoped>
</style>